import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  ListProps,
  FunctionField,
} from "react-admin";
import TypeField from "../../components/TypeField";
import CustomDateField from "../../components/CustomDateField";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ActionsMenu from "../../components/ActionsMenu";

const NotificationFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const NotificationList = (props: ListProps) => {
  const breadcrumb = [{ link: "/notifications", title: "Notifications" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Notifications"
        isNotHaveSchoolFilter
        denseMode
        exporter={false}
        filters={<NotificationFilter />}
        bulkActionButtons={false}
        sort={{ field: "CreatedAt", order: "DESC" }}
        {...props}
      >
        <Datagrid>
          <TextField source="id" />
          <TypeField source="targetType" type="notificationTarget_Type" />
          <TextField source="title" />
          <TextField source="body" />
          <CustomDateField
            source="createdAt"
            label="Created At"
            emptyText="-"
            isDateTime
          />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu render={[<ListShowButton record={record} />]} />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default NotificationList;
